// The app's few line icons (16px, stroke = currentColor; styled by .icon in styles.css). Always
// decorative: the button or link around one carries the accessible name.
import type { JSX } from "preact";

export type IconName =
  | "calendar"
  | "chevron-down"
  | "chevron-left"
  | "chevron-right"
  | "copy"
  | "check"
  | "close"
  | "download"
  | "search"
  | "menu"
  | "plus"
  | "external"
  | "sun"
  | "moon";

const PATHS: Record<IconName, JSX.Element> = {
  calendar: (
    <>
      <rect x="2" y="3" width="12" height="11" rx="2" />
      <path d="M2 6.5h12M5.5 1.5v3M10.5 1.5v3" />
    </>
  ),
  "chevron-down": <path d="M4 6l4 4 4-4" />,
  "chevron-left": <path d="M10 4L6 8l4 4" />,
  "chevron-right": <path d="M6 4l4 4-4 4" />,
  copy: (
    <>
      <rect x="5.5" y="5.5" width="8" height="8" rx="1.5" />
      <path d="M10.5 5.5V3.5a1.5 1.5 0 0 0-1.5-1.5H3.5A1.5 1.5 0 0 0 2 3.5V9a1.5 1.5 0 0 0 1.5 1.5h2" />
    </>
  ),
  check: <path d="M3 8.5l3 3 7-7" />,
  close: <path d="M4 4l8 8M12 4l-8 8" />,
  download: <path d="M8 2v8M4.5 6.5 8 10l3.5-3.5M2.5 13.5h11" />,
  search: (
    <>
      <circle cx="7" cy="7" r="4.5" />
      <path d="M10.5 10.5 14 14" />
    </>
  ),
  menu: <path d="M2.5 4h11M2.5 8h11M2.5 12h11" />,
  plus: <path d="M8 3v10M3 8h10" />,
  external: <path d="M9 2.5h4.5V7M13.5 2.5 7 9M11.5 9.5v3a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3" />,
  sun: (
    <>
      <circle cx="8" cy="8" r="3" />
      <path d="M8 1.5v1.25M8 13.25v1.25M1.5 8h1.25M13.25 8h1.25M3.4 3.4l.9.9M11.7 11.7l.9.9M3.4 12.6l.9-.9M11.7 4.3l.9-.9" />
    </>
  ),
  moon: <path d="M13.5 9.6A5.75 5.75 0 1 1 6.4 2.5a4.5 4.5 0 0 0 7.1 7.1z" />,
};

export function Icon({ name, small }: { name: IconName; small?: boolean }) {
  return (
    <svg class={small ? "icon icon-sm" : "icon"} viewBox="0 0 16 16" aria-hidden="true" focusable="false">
      {PATHS[name]}
    </svg>
  );
}
